// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/portfolio-configuration/app/css/app.css
// module id = 833
// module chunks = 0